import { Injectable } from '@angular/core';

@Injectable()
export class NewWindowService {

  constructor() { }
  
  getNativeWindow() {
      return window;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/new-window/new-window.service.ts